// Add your custom JS here.

(function ($) {
  $(document).ready(function() {
    Array.from(document.querySelectorAll('.block-sticky-menu')).forEach((element) => {
      if (!$(element).hasClass('initialized')) {
        $(element).addClass('initialized');
        const ul = element.querySelector('ul');
        ul.style.width = element.getBoundingClientRect().width + 'px';
        element.nextElementSibling.style.height = (element.getBoundingClientRect().height) + 'px';
        let stickyBitStickyOffset = 0;
        if ($(element).position().top > 0) {
          stickyBitStickyOffset = $(element).position().top * -1;
        }
        const sticky = stickybits(element, { useFixed: true, stickyBitStickyOffset  });
        window.addEventListener('resize', () => {
          ul.style.width = element.parentNode.getBoundingClientRect().width + 'px';
          element.nextElementSibling.style.height = (element.getBoundingClientRect().height) + 'px';
          let stickyBitStickyOffset = 0;
          if ($(element).position().top > 0) {
            stickyBitStickyOffset = $(element).position().top * -1;
          }
          sticky.update({ stickyBitStickyOffset  });
        });
      }
    });

    // Page How to Pick a School Gravity Form
    $('form.how-to-pick-school li.gsection').each(function () {
      $(this).click(function () {
        $(this).next('li.explanation_v2').toggle();
        $(this).next('li.explanation_v2').next('li.things_v2').toggle();
        $(this).next('li.explanation_v2').next('li.things_v2').next('li.questions_v2').toggle();

        $(this).toggleClass('visible');
        $(this).next('li.explanation_v2').next('li.things_v2').toggleClass('visible');
        $(this).next('li.explanation_v2').next('li.things_v2').next('li.questions_v2').toggleClass('visible');
      });
    });

    $('form.how-to-pick-school').each(function () {
      if (window.location.href.indexOf('es') > -1) {
        $(this).find('input[type="button"][value="Get started!"]').attr('value', '¡Comience!');
        $(this).find('input[type="button"][value="Next"]').attr('value', 'Siguiente');
        $(this).find('input[type="button"][value="Previous"]').attr('value', 'Anterior');
        $(this).find('input[type="submit"][value="Get my personalized report!"]').attr('value', '¡Obtener mi informe personalizado!');
      }
      if (window.location.href.indexOf('so') > -1) {
        $(this).find('input[type="button"][value="Get started!"]').attr('value', 'Bilow!');
        $(this).find('input[type="button"][value="Next"]').attr('value', 'Xiga');
        $(this).find('input[type="button"][value="Previous"]').attr('value', 'Hore');
        $(this).find('input[type="submit"][value="Get my personalized report!"]').attr('value', 'Hel warbixintayda shaqsiga ah!');
      }
    });

    // Faking in the menu to act on hover instead of click
    $('#navbarNavDropdown .dropdown').on('mouseenter', () => {
      $('.dropdown > a').addClass('show')
      $('.dropdown > a').attr('aria-expanded', 'true');
      $('.dropdown > ul').attr('data-bs-popper', 'none');
      $('.dropdown > ul').addClass('show')
    })

    $('#navbarNavDropdown .dropdown').on('mouseleave', () => {
      $('.dropdown > a').removeClass('show')
      $('.dropdown > a').attr('aria-expanded', 'false');
      $('.dropdown > ul').removeAttr('data-bs-popper', 'none');
      $('.dropdown > ul').removeClass('show')
    })

    // Move modals to the end of the body to avoid z-index issues.
    var bsModals = document.querySelectorAll('.modal');
    if (bsModals) {
      Array.from(bsModals).forEach((modal) => {
        document.body.appendChild(modal);
      });
    }
  });
})(jQuery);